import router from '@/router'
import api from '@/apis'

export default {
  state: {
    status: true,
    token: null,
    username: null,
    project_id: null,
    user_id: null,
    role_id: null,
    page_access: [],

    step: 1,
    post_login_action_required: false
  },
  mutations: {
    SET_AUTH_STATUS(state, { user_id, username, project_id, token, page_access, role_id }) {
      state.status = true
      state.token = token
      state.username = username
      state.project_id = project_id
      state.user_id = user_id
      state.role_id = role_id
      state.page_access = page_access
    },
    RESET_AUTH_STATUS(state) {
      state.status = false
      state.token = null
      state.username = null
      state.project_id = null
      state.user_id = null
      state.role_id = null
      state.page_access = []

      state.step = 1
      state.post_login_action_required = false
    },
    SET_AUTH_STEP(state, payload) {
      state.step = payload
    },
    SET_AUTH_POST_LOGIN_ACTION_REQUIRED(state, payload) {
      state.post_login_action_required = payload
    }
  },
  actions: {
    async authenticateUser({ commit, dispatch }, payload) {
      try {
        commit('SET_SNACKBAR', { status: true, color: 'loading', text: 'Authenticating...', loading: true })
        const response = await api.login(payload)
        if (response.data.success) {
          const { user_id, username, project_id, access_token, page_access, role_id, reset_password_required, enable_2fa } = response.data.data
          commit('SET_SNACKBAR', { status: true, color: 'success', text: response.data.message, icon: 'check', timeout: '2000' })
          commit('SET_AUTH_STATUS', { user_id, username, project_id, token: access_token, page_access, role_id, reset_password_required, enable_2fa, user_info: response.data.data })

          if (enable_2fa || reset_password_required) commit('SET_AUTH_POST_LOGIN_ACTION_REQUIRED', true)
          if (enable_2fa) commit('SET_AUTH_STEP', 2)
          else if (reset_password_required) commit('SET_AUTH_STEP', 3)
          else dispatch('routeToFirstPage')

          // if (reset_password_required) commit('INIT_RESET_PASSWORD_DIALOG', user_id)
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      }
    },
    async logoutUser({ commit, dispatch, state }) {
      try {
        commit('SET_SNACKBAR', { status: true, color: 'loading', text: 'Logging out...', loading: true })
        const response = await api.logout({ params: { access_token: state.token } })
        if (response.data.success) commit('SET_SNACKBAR', { status: true, color: 'success', text: response.data.message, icon: 'check', timeout: '2000' })
        else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        dispatch('expireUser')
      }
    },
    async expireUser({ commit }) {
      commit('RESET_AUTH_STATUS')
      if (router.currentRoute.path !== '/') router.push({ path: '/' })
    },
    async verifyToken({ commit, dispatch, state }) {
      try {
        if (state.status && !state.post_login_action_required) {
          const response = await api.verifyToken({ params: { access_token: state.token } })
          if (!response.data.success) throw Error(response.data.message)
        }
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
        dispatch('expireUser')
      }
    },
    async verifyOTP({ commit, state, dispatch }, payload) {
      try {
        const response = await api.verifyOTP({ params: { access_token: state.token, otp: payload } })
        if (response.data.success) {
          const { user_id, username, project_id, access_token, page_access, role_id, reset_password_required, enable_2fa } = response.data.data
          commit('SET_AUTH_STATUS', { user_id, username, project_id, token: access_token, page_access, role_id, reset_password_required, enable_2fa, user_info: response.data.data })

          if (reset_password_required) commit('SET_AUTH_STEP', 3)
          else {
            commit('SET_AUTH_POST_LOGIN_ACTION_REQUIRED', false)
            dispatch('routeToFirstPage')
          }
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      }
    },
    routeToFirstPage({ state }) {
      const first_page = state.page_access[0]
      router.push({ path: first_page })
    }
  }
}
